<template>
  <div style="height: 100%;">
    <el-container style="height: 100%;">
      <template v-if="isMobile">
          <div class="mubu" v-if="navShowOff" @click="navShowOff = !navShowOff"></div>
      </template>

      <!-- 左侧导航 -->
      <template v-if="!isMobile">
          <el-aside v-if="navShowOff" width="200px" style="height: 100%;background-color: #3165D2;"></el-aside>
      </template>

      <el-aside v-if="navShowOff" width="200px" style="background-color: #3165D2;height: 100%;overflow: unset;position: fixed;top:0px;left:0px;z-index: 999;">

        <div class="wp100 h60 dcc c_bai shadowBottom" style="background: #3E7BFA;margin-bottom: 20px;">
          <img class="h20 mr10" src="@/static/data/icon/icon.png" />
          <div>线上课程系统平台</div>
        </div>

        <el-aside style="height: calc(100% - 60px);;overflow-y: auto;background-color: #3165D2;">

          <el-menu 

            active-text-color="#fff"
            background-color="#3165D2"
            text-color="#E9E9EB"

            :collapse="isCollapse" 
            default-active="a" 
            class="el-menu-vertical-demo" 
            :unique-opened="true" 
            v-if="user"
          >
            <el-menu-item index="a" @click="url('/' + port + '/index/index','',key1)">
              <el-icon size="20">
                <component :is="'Monitor'" />
              </el-icon>
              <span>数据看板</span>
            </el-menu-item>

            <template v-if="nav && nav[port]">
            <template v-for="(val1, key1) in nav[port]" :key="key1">
              <template v-if="val1.children.length == 0">

                <el-menu-item :index="key1 + ''" @click="url(val1.url,val1.scene,key1)">

                  <img v-if="val1.pic && val1.pic.length > 0 && menuKey != key1" :src="fileHost+val1.pic" style="width: 16px;" class="mr10">
                  <img v-if="val1.pics && val1.pics.length > 0 && menuKey == key1" :src="fileHost+val1.pics" style="width: 16px;" class="mr10">
                  <el-icon v-else-if="val1.inc.length > 0" size="20">
                    <component :is="val1.inc" :color="val1.color" />
                  </el-icon>
                  
                  {{ val1.title }}
                
                </el-menu-item>

              </template>
              <template v-else>

                <el-sub-menu :index="key1 + ''">

                  <template #title>
                    <img v-if="val1.pic && val1.pic.length > 0 && menuKey != key1" :src="fileHost+val1.pic" style="width: 16px;" class="mr10">
                    <img v-if="val1.pics && val1.pics.length > 0 && menuKey == key1" :src="fileHost+val1.pics" style="width: 16px;" class="mr10">
                    <el-icon v-else-if="val1.inc.length > 0" size="20">
                      <component :is="val1.inc" :color="val1.color" />
                    </el-icon>
                    <span>{{ val1.title }}</span>
                  </template>

                  <template v-for="(val2, key2) in val1.children" :key="key2">
                    <template v-if="val2.children.length == 0">
                      <el-menu-item :index="key1 + '-' + key2" @click="url(val2.url,val1.scene,key1)">{{ val2.title }}</el-menu-item>
                    </template>
                    <template v-else>
                      <el-sub-menu :index="key1 + '-' + key2">
                        <template #title><span>{{ val2.title }}</span></template>
                        <template v-for="(val3, key3) in val2.children" :key="key3">
                          <el-menu-item :index="key1 + '-' + key2 + '-' + key3"
                            @click="url(val3.url,val1.scene,key1)">{{ val3.title }}</el-menu-item>
                        </template>
                      </el-sub-menu>
                    </template>
                  </template>

                </el-sub-menu>

              </template>
            </template>
            </template>

          </el-menu>

        </el-aside>

      </el-aside>
      <!-- 左侧导航 end -->

      <el-container style="height: 100%;">

        <el-header class="df jcsb aic header1 pr shadowBottom" style="height:60px;">

          <div class="showNavPostion df jcc aic" @click="navShowOff = !navShowOff" :style="'left:'+(isMobile && navShowOff ? 200 : 10)+'px;'">
            <el-icon v-if="navShowOff"  size="30"><Fold /></el-icon>
            <el-icon v-else  size="30"><Expand /></el-icon>
          </div>

          <div></div>

          <div class="df jcc aic header2" style="height:60px;">
            <el-dropdown v-if="user" @command="handleCommand">
              <div class="el-dropdown-link df jcfe aic" style="outline: unset;">

                <img class="wh40 mr10" v-if="user.qsw_user.user[portKey[port]].port_pic_str" :src="fileHost+user.qsw_user.user[portKey[port]].port_pic_str" />
                <img class="wh40 mr10" v-else src="@/static/data/login/pic.png" />
                
                <div>
                  <div class="f14 mb5 b">
                    {{ user.qsw_user.t_nickname }}
                  </div>
                  <div style="color: #999;">
                    {{ user.qsw_user.user[user.qsw_user.login_port].port_name }}
                    <template v-if="port == 'admin'">（主后台）</template>
                    <template v-if="port == 'agency'">（后台端）</template>
                    <template v-if="port == 'area'">（管理端）</template>
                    <template v-if="port == 'sell'">（代理端）</template>
                    <template v-if="port == 'serve'">（交付中心端）</template>
                  </div>
                </div>

                <el-icon class="el-icon--right">
                  <arrow-down />
                </el-icon>
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="loginDel">退出登录</el-dropdown-item>
                  <el-dropdown-item command="rankUp">更新权限</el-dropdown-item>

                  <template v-for="(val, key) in user.port_list" :key="key">
                    <el-dropdown-item :command="'login:' + val.id + ':' + val.port">
                      <span>切换到：{{ val.name }} </span>
                      <span v-if="val.id > 0">({{ val.port_name }})</span>
                    </el-dropdown-item>
                  </template>

                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
          
        </el-header>
        <!-- <el-header class="df jcsb aic header1 pr" style="height:60px;background-color: #E4EBF8;">
          <div class="wp100_40 hp100 mlr20 df jcfs aife ox">
            <div class="h40 plr10 dcc mr10 f14 cheNavBut" style="border-radius: 5px 5px 0px 0px;">
              <span class="mr10">数据看板</span>
              <el-icon><CloseBold /></el-icon>
            </div>

            <div class="h40 plr10 dcc mr10 f14" style="border-radius: 5px 5px 0px 0px;background-color: #D8E0EF;color: #8C9AB5;">
              <span class="mr10">数据看板</span>
              <el-icon><CloseBold /></el-icon>
            </div>
          </div>
        </el-header> -->

        <el-main :style="'height: 100%;position: relative;'+(isMobile ? 'padding: unset;' : '')">
          
          <slot></slot>
        </el-main>

      </el-container>
    </el-container>
  </div>
</template>
    
<script>

import {timeIntValue} from '@/timer/index.js'
export default {
  name: 'HomeItem',

  props: {
    port: {
      types: Number,
      default: 'admin'
    }
  },

  computed: {
    user() {
      this.getViewData();
      return this.$store.state.user;
    }
  },

  watch: {
    timeIntValue(){
      this.timeIntValueInt += 1;

      if(this.timeIntValueInt % 5 == 0){
        if(this.port == 'serve'){
          this.getMsgCou();
        }
      }
    }
  },

  data() {

    var isMobile = this.$store.state.isMobile;
    var navShowOff = !isMobile;

    return {
      fileHost: this.util.config.fileHost,
      nav: 0,
      isCollapse: false,
      formSubOff:false,
      isMobile:isMobile,
      navShowOff:navShowOff,

      timeIntValue,
      timeIntValueInt:0,

      menuKey:'a',

      portKey:{
        admin:1,
        agency:2,
        area:3,
        sell:4,
        serve:5,
      }
    }
  },

  // 创建之前
  beforeCreate() {
  },

  // 创建完
  created() {
  },

  // 挂载dom之后
	mounted(){
		// this.$refs.mianPage.setData({},true,true)
    this.getViewData();

	},

  methods: {

    getMsgCou(){
      var that = this;

      that.util.request({
        url:'/coom/port/getOrderUp',
        data:{},
        load:false,
        success(res){
          that.msg = res.data;
          if(that.msg && that.msg.msg_cou > 0){
            that.util.alertTwo({
              title: '',
              value: '有 '+that.msg.msg_cou+'个 课程申请需要处理',
              type: 'warning',
              duration:0
            })
          }

        }
      })

    },

    getViewData(){
      var that = this;
      that.nav = that.$store.state.nav
      that.util.loginIs(function () {
        that.nav = that.$store.state.nav
      }, true, true);
    },

    url(path,scene = '',menuKey = 'a') {
      this.$store.state.nav_scene_data = scene
      this.$router.push({
        path: path
      })

      this.menuKey = menuKey
    },

    handleCommand(val) {
      console.log('val', val)
      var that = this;

      if (val == 'loginDel') {
        that.util.logout()
      } else if (val == 'rankUp') {
        that.util.loginIs(function () {
          that.user = that.$store.state.user
          that.nav = that.$store.state.nav
        }, true, true);
      } else {
        val = val.split(':');
        if (val.length == 3) {
          if (val[0] == 'login') {
            that.ajax('/login/user/port',{
              port_id:val[1],
              login_port:val[2],
            },function(res){

              if(res.code == 200){
                var user = res.data;

                that.util.setLogin(user)

                that.util.alert({
                  cancel:false,
                  value:res.msg,
                  success:function(){
                    that.util.loginUrl();
                  }
                })
              }else{
                that.util.alert({
                  cancel:false,
                  value:res.msg,
                })
              }

            })
          }
        }
      }

    },

    ajax(url, data = {}, fun = '') {
      var that = this

      if (that.formSubOff) {
        return false;
      }
      that.formSubOff = true;
      data.port_type = that.port_type

      that.util.request({
        url: url,
        data: data,
        success(res) {
          that.formSubOff = false;
          fun ? fun(res) : '' ;
          console.log('nav_ok', res)
        },
        fail(res) {
          console.log('nav_fail', res)
        }
      })
    },

  },
}

</script>
  
  
<style lang="less">
// 全局css

#app {
  height: 100vh;
}

.el-menu{
  border:0px !important;
  .is-active{
    background-color: #3E7BFA !important;
  }
}

.cheNavBut{
  background-color: #fff !important;
  color:#3E7BFA !important;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 198px;
  min-height: 400px;
}

.el-container::-webkit-scrollbar {
  display: none
}

.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar {
  height: 15px;
}

.el-table__fixed .el-table__body {
  padding-bottom: 15px;
}

.el-table__fixed-right .el-table__body {
  padding-bottom: 15px;
}

.header1,
.header2 {
  width: auto;
  height: 40px;
  padding: 0 10px;
  background: #fff;
  cursor: pointer;
}

.header2 {
  .el-dropdown-link {
    display: flex;
    align-items: center;
  }
}

.header1{
  border-bottom: 1px solid #E4E7ED;
  span{
    font-size: 12px;
  }
}

.mubu{
  width: 100%;
  height: 100%;
  position: fixed;
  left:0px;
  bottom:0px;
  z-index: 998;
  background-color: rgba(0,0,0,0.5);
}

.showNavPostion{
  width:40px;
  height: 40px;
  // background-color: rgba(0, 0, 0, .7);
  // color: #fff;
  position: absolute;
  bottom:calc(50% - 15px);
  z-index: 999;
}
</style>
  
  